/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Clear_Selection_ButtonInputs */



/**
* | output |
* | --- |
* | "Clear Selection" |
*
* @param {Explorer_Display_Clear_Selection_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_clear_selection_button = /** @type {((inputs?: Explorer_Display_Clear_Selection_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Clear_Selection_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer la selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auswahl löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella selezione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить выбор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar selección")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択をクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयन साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar seleção")
	return /** @type {LocalizedString} */ ("Clear Selection")
});